// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2GurQ","inputWrap":"CustomTip_inputWrap__2Opvy"};